



















import mixins from 'vue-typed-mixins';
import OversightUtils, {
  OversightOrganizationType,
} from '../../utils/OversightUtils';
import OversightTypeForm from '@/components/oversight/OversightTypeForm.vue';
export default mixins().extend({
  components: {
    OversightTypeForm,
  },
  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },
  },
  data(): {
    type?: Partial<OversightOrganizationType>;
  } {
    return {
      type: {
        name: this.$languageobj(),
        scope: {
          children_type: undefined,
          children_oversight_org_type: undefined,
          mutually_exclusive_children: false,
        },
      },
    };
  },
  methods: {
    async submit() {
      if (this.type) {
        try {
          this.$alert.hide('submit');

          await OversightUtils.api.type.add(
            this.type as OversightOrganizationType
          );
          await this.$router.push({ name: 'oversight-type-list' });

          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.add', {
              values: [this.type.name],
            }),
          });
        } catch (error) {
          this.$alert.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error, this.$refs.observer),
          });
        }
      }
    },
  },
});
